export default __webpack_public_path__ + "locales/tr/JavascriptSdk.json?hash=9b367118a5846e1525090fcf5559dc94";